
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexETfTzvfnAiJSiwB7zg1Pn9EyH6NB3fdPWo1oMdKdffYMeta } from "/opt/render/project/src/apps/frontend/pages/index.vue?macro=true";
import { default as faqJzKeg7hdi3lCe68w6_45WLVZ2vhe7hkqXznZLuw8LbXtAMeta } from "/opt/render/project/src/apps/frontend/pages/faq.vue?macro=true";
import { default as logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta } from "/opt/render/project/src/apps/frontend/pages/login.vue?macro=true";
import { default as black_45week5VOkyFl7b7z2ldLHW1pdVB1pmXTcvIbzDehFHiGgfXAMeta } from "/opt/render/project/src/apps/frontend/pages/black-week.vue?macro=true";
import { default as _91vin_93mAeJ2rvzZiImkEDNmLrGhpvfx8_45KqgMxiAYFXSubtB4Meta } from "/opt/render/project/src/apps/frontend/pages/go/v/[vin].vue?macro=true";
import { default as bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta } from "/opt/render/project/src/apps/frontend/pages/account/bids.vue?macro=true";
import { default as indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta } from "/opt/render/project/src/apps/frontend/pages/signup/index.vue?macro=true";
import { default as cookie_45policy_45fsj05BC48JCVXvoZ7cIN1ouT09hS8VHUwUHcHLEINQMeta } from "/opt/render/project/src/apps/frontend/pages/cookie-policy.vue?macro=true";
import { default as pricing_45buyerfkCUJq8ybvLu_45GDOl7uORGpg8zuHeYXTHRLrfc3cbX8Meta } from "/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue?macro=true";
import { default as password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta } from "/opt/render/project/src/apps/frontend/pages/password-reset.vue?macro=true";
import { default as pricing_45sellerpWKJSGwOjnkyMPKIFxURL_rk8uwj67JlX1hQAXkxGBMMeta } from "/opt/render/project/src/apps/frontend/pages/pricing-seller.vue?macro=true";
import { default as privacy_45policyDrW8X9Dv2XnXHtv9f_45Gi6bxMRAU0_45Mb5Nwp_LZynCh8Meta } from "/opt/render/project/src/apps/frontend/pages/privacy-policy.vue?macro=true";
import { default as confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta } from "/opt/render/project/src/apps/frontend/pages/signup/confirm.vue?macro=true";
import { default as profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta } from "/opt/render/project/src/apps/frontend/pages/account/profile.vue?macro=true";
import { default as _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta } from "/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue?macro=true";
import { default as indextYlnt5YkX2LB_45Wa_45oJzKeiQNO1CG6GewGchZQVmW7tEMeta } from "/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue?macro=true";
import { default as paymentTXdQALaMzzkMW3tVVDol_45mBKxUYMtywz0jS67zw5nHUMeta } from "/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue?macro=true";
import { default as editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta } from "/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue?macro=true";
import { default as indexoPf_45VzW3vt1qkwAADsRAeiHlA03sxujM9SCoTxgfzb0Meta } from "/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue?macro=true";
import { default as thank_45youjxs6JOzE4t5weFUlKI_VTLMmYQF5lU9fWGdGqjtN77sMeta } from "/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue?macro=true";
import { default as _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta } from "/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue?macro=true";
import { default as trust_45reportReSPYhGQ9QzSd9FFL5hZVVMVtmKDseINVuL_45YVDswdYMeta } from "/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue?macro=true";
import { default as indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta } from "/opt/render/project/src/apps/frontend/pages/account/orders/index.vue?macro=true";
import { default as terms_45and_45conditionsZui_zQ58P7o0mtCzP7at7hYi_45IdyVF_Q0g6of3HKR5UMeta } from "/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue?macro=true";
import { default as your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta } from "/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue?macro=true";
import { default as accessibility_45statementbp5Pk68EZTKCT2VXTje9aBGvllUSroRi82_tgzwaN20Meta } from "/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue?macro=true";
import { default as payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta } from "/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue?macro=true";
import { default as how_45sell_45used_45bus4gJy7PlEker4UoJj9tW6TRcUCW57IwSJnPbhoPJoamgMeta } from "/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue?macro=true";
import { default as your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta } from "/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue?macro=true";
import { default as guide_45buy_45used_45busD606PAlC5G4lPM1y6WJ3TF_45n2Uzd34mhBhCZ87ZZxjwMeta } from "/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue?macro=true";
import { default as index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta } from "/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue?macro=true";
import { default as reasons_45buy_45bus_45auctionYYFW1P79uY99eM_45XaQBFLzAE3XPGUj0wiGXY1w1GxL8Meta } from "/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue?macro=true";
import { default as logistics_45terms_45and_45conditionsT_45KeUqaFOp2aJg4o7_45xp0ukw1KSra3sCRv9EDK_45gctUMeta } from "/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue?macro=true";
import { default as negotiationM6IegD7q8eZhnnjrNhb3T254h016Ep0UXQouNjGkxLIMeta } from "/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue?macro=true";
import { default as your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta } from "/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue?macro=true";
import { default as _91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta } from "/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue?macro=true";
import { default as _91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta } from "/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue?macro=true";
import { default as component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta } from "/opt/render/project/src/apps/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM } from "/opt/render/project/src/apps/frontend/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "faq___cs",
    path: "/cs/faq",
    component: () => import("/opt/render/project/src/apps/frontend/pages/faq.vue")
  },
  {
    name: "faq___de",
    path: "/de/faq",
    component: () => import("/opt/render/project/src/apps/frontend/pages/faq.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    component: () => import("/opt/render/project/src/apps/frontend/pages/faq.vue")
  },
  {
    name: "faq___es",
    path: "/es/faq",
    component: () => import("/opt/render/project/src/apps/frontend/pages/faq.vue")
  },
  {
    name: "faq___fr",
    path: "/fr/faq",
    component: () => import("/opt/render/project/src/apps/frontend/pages/faq.vue")
  },
  {
    name: "faq___it",
    path: "/it/faq",
    component: () => import("/opt/render/project/src/apps/frontend/pages/faq.vue")
  },
  {
    name: "faq___nl",
    path: "/nl/faq",
    component: () => import("/opt/render/project/src/apps/frontend/pages/faq.vue")
  },
  {
    name: "faq___pl",
    path: "/pl/faq",
    component: () => import("/opt/render/project/src/apps/frontend/pages/faq.vue")
  },
  {
    name: "faq___pt",
    path: "/pt/faq",
    component: () => import("/opt/render/project/src/apps/frontend/pages/faq.vue")
  },
  {
    name: "faq___ro",
    path: "/ro/faq",
    component: () => import("/opt/render/project/src/apps/frontend/pages/faq.vue")
  },
  {
    name: "faq___ru",
    path: "/ru/faq",
    component: () => import("/opt/render/project/src/apps/frontend/pages/faq.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "index___pl",
    path: "/pl",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/opt/render/project/src/apps/frontend/pages/index.vue")
  },
  {
    name: "login___cs",
    path: "/cs/login",
    meta: { ...(logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: { ...(logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: { ...(logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: { ...(logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: { ...(logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/login.vue")
  },
  {
    name: "login___it",
    path: "/it/login",
    meta: { ...(logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/login.vue")
  },
  {
    name: "login___nl",
    path: "/nl/login",
    meta: { ...(logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/login.vue")
  },
  {
    name: "login___pl",
    path: "/pl/login",
    meta: { ...(logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/login.vue")
  },
  {
    name: "login___pt",
    path: "/pt/login",
    meta: { ...(logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/login.vue")
  },
  {
    name: "login___ro",
    path: "/ro/login",
    meta: { ...(logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/login.vue")
  },
  {
    name: "login___ru",
    path: "/ru/login",
    meta: { ...(logintyaXdVQW5K0vKEy3ImzUNIbHV2ikNgbdnFAZ_M8dzo4Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/login.vue")
  },
  {
    name: "black-week___cs",
    path: "/cs/black-week",
    component: () => import("/opt/render/project/src/apps/frontend/pages/black-week.vue")
  },
  {
    name: "black-week___de",
    path: "/de/black-week",
    component: () => import("/opt/render/project/src/apps/frontend/pages/black-week.vue")
  },
  {
    name: "black-week___en",
    path: "/en/black-week",
    component: () => import("/opt/render/project/src/apps/frontend/pages/black-week.vue")
  },
  {
    name: "black-week___es",
    path: "/es/black-week",
    component: () => import("/opt/render/project/src/apps/frontend/pages/black-week.vue")
  },
  {
    name: "black-week___fr",
    path: "/fr/black-week",
    component: () => import("/opt/render/project/src/apps/frontend/pages/black-week.vue")
  },
  {
    name: "black-week___it",
    path: "/it/black-week",
    component: () => import("/opt/render/project/src/apps/frontend/pages/black-week.vue")
  },
  {
    name: "black-week___nl",
    path: "/nl/black-week",
    component: () => import("/opt/render/project/src/apps/frontend/pages/black-week.vue")
  },
  {
    name: "black-week___pl",
    path: "/pl/black-week",
    component: () => import("/opt/render/project/src/apps/frontend/pages/black-week.vue")
  },
  {
    name: "black-week___pt",
    path: "/pt/black-week",
    component: () => import("/opt/render/project/src/apps/frontend/pages/black-week.vue")
  },
  {
    name: "black-week___ro",
    path: "/ro/black-week",
    component: () => import("/opt/render/project/src/apps/frontend/pages/black-week.vue")
  },
  {
    name: "black-week___ru",
    path: "/ru/black-week",
    component: () => import("/opt/render/project/src/apps/frontend/pages/black-week.vue")
  },
  {
    name: "go-v-vin",
    path: "/go/v/:vin()",
    meta: {"middleware":"smart-link-vehicle-resolver"},
    component: () => import("/opt/render/project/src/apps/frontend/pages/go/v/[vin].vue")
  },
  {
    name: "account-bids___cs",
    path: "/cs/account/bids",
    meta: { ...(bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/bids.vue")
  },
  {
    name: "account-bids___de",
    path: "/de/account/bids",
    meta: { ...(bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/bids.vue")
  },
  {
    name: "account-bids___en",
    path: "/en/account/bids",
    meta: { ...(bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/bids.vue")
  },
  {
    name: "account-bids___es",
    path: "/es/account/bids",
    meta: { ...(bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/bids.vue")
  },
  {
    name: "account-bids___fr",
    path: "/fr/account/bids",
    meta: { ...(bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/bids.vue")
  },
  {
    name: "account-bids___it",
    path: "/it/account/bids",
    meta: { ...(bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/bids.vue")
  },
  {
    name: "account-bids___nl",
    path: "/nl/account/bids",
    meta: { ...(bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/bids.vue")
  },
  {
    name: "account-bids___pl",
    path: "/pl/account/bids",
    meta: { ...(bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/bids.vue")
  },
  {
    name: "account-bids___pt",
    path: "/pt/account/bids",
    meta: { ...(bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/bids.vue")
  },
  {
    name: "account-bids___ro",
    path: "/ro/account/bids",
    meta: { ...(bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/bids.vue")
  },
  {
    name: "account-bids___ru",
    path: "/ru/account/bids",
    meta: { ...(bidsdTcJXc_45fcLRT_45pwW_nQN4boIxawoIfWeR5aa104WefEMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/bids.vue")
  },
  {
    name: "signup___cs",
    path: "/cs/signup",
    meta: { ...(indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/index.vue")
  },
  {
    name: "signup___de",
    path: "/de/signup",
    meta: { ...(indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/index.vue")
  },
  {
    name: "signup___en",
    path: "/en/signup",
    meta: { ...(indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/index.vue")
  },
  {
    name: "signup___es",
    path: "/es/signup",
    meta: { ...(indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/index.vue")
  },
  {
    name: "signup___fr",
    path: "/fr/signup",
    meta: { ...(indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/index.vue")
  },
  {
    name: "signup___it",
    path: "/it/signup",
    meta: { ...(indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/index.vue")
  },
  {
    name: "signup___nl",
    path: "/nl/signup",
    meta: { ...(indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/index.vue")
  },
  {
    name: "signup___pl",
    path: "/pl/signup",
    meta: { ...(indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/index.vue")
  },
  {
    name: "signup___pt",
    path: "/pt/signup",
    meta: { ...(indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/index.vue")
  },
  {
    name: "signup___ro",
    path: "/ro/signup",
    meta: { ...(indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/index.vue")
  },
  {
    name: "signup___ru",
    path: "/ru/signup",
    meta: { ...(indexzwE5NoPtRk_zWTpv9QyvqxwV4tiL5ipHLQ9kYpJOBbsMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/index.vue")
  },
  {
    name: "cookie-policy___cs",
    path: "/cs/cookie-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___de",
    path: "/de/cookie-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___en",
    path: "/en/cookie-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___es",
    path: "/es/cookie-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___fr",
    path: "/fr/cookie-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___it",
    path: "/it/cookie-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___nl",
    path: "/nl/cookie-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___pl",
    path: "/pl/cookie-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___pt",
    path: "/pt/cookie-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___ro",
    path: "/ro/cookie-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/cookie-policy.vue")
  },
  {
    name: "cookie-policy___ru",
    path: "/ru/cookie-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/cookie-policy.vue")
  },
  {
    name: "pricing-buyer___cs",
    path: "/cs/pricing-buyer",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue")
  },
  {
    name: "pricing-buyer___de",
    path: "/de/pricing-buyer",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue")
  },
  {
    name: "pricing-buyer___en",
    path: "/en/pricing-buyer",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue")
  },
  {
    name: "pricing-buyer___es",
    path: "/es/pricing-buyer",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue")
  },
  {
    name: "pricing-buyer___fr",
    path: "/fr/pricing-buyer",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue")
  },
  {
    name: "pricing-buyer___it",
    path: "/it/pricing-buyer",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue")
  },
  {
    name: "pricing-buyer___nl",
    path: "/nl/pricing-buyer",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue")
  },
  {
    name: "pricing-buyer___pl",
    path: "/pl/pricing-buyer",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue")
  },
  {
    name: "pricing-buyer___pt",
    path: "/pt/pricing-buyer",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue")
  },
  {
    name: "pricing-buyer___ro",
    path: "/ro/pricing-buyer",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue")
  },
  {
    name: "pricing-buyer___ru",
    path: "/ru/pricing-buyer",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-buyer.vue")
  },
  {
    name: "password-reset___cs",
    path: "/cs/password-reset",
    meta: password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/password-reset.vue")
  },
  {
    name: "password-reset___de",
    path: "/de/password-reset",
    meta: password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/password-reset.vue")
  },
  {
    name: "password-reset___en",
    path: "/en/password-reset",
    meta: password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/password-reset.vue")
  },
  {
    name: "password-reset___es",
    path: "/es/password-reset",
    meta: password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/password-reset.vue")
  },
  {
    name: "password-reset___fr",
    path: "/fr/password-reset",
    meta: password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/password-reset.vue")
  },
  {
    name: "password-reset___it",
    path: "/it/password-reset",
    meta: password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/password-reset.vue")
  },
  {
    name: "password-reset___nl",
    path: "/nl/password-reset",
    meta: password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/password-reset.vue")
  },
  {
    name: "password-reset___pl",
    path: "/pl/password-reset",
    meta: password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/password-reset.vue")
  },
  {
    name: "password-reset___pt",
    path: "/pt/password-reset",
    meta: password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/password-reset.vue")
  },
  {
    name: "password-reset___ro",
    path: "/ro/password-reset",
    meta: password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/password-reset.vue")
  },
  {
    name: "password-reset___ru",
    path: "/ru/password-reset",
    meta: password_45resetH2_WxzPOEoUiFQGtkrVBvz9EQGonuNXeDnlikk6OgOIMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/password-reset.vue")
  },
  {
    name: "pricing-seller___cs",
    path: "/cs/pricing-seller",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-seller.vue")
  },
  {
    name: "pricing-seller___de",
    path: "/de/pricing-seller",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-seller.vue")
  },
  {
    name: "pricing-seller___en",
    path: "/en/pricing-seller",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-seller.vue")
  },
  {
    name: "pricing-seller___es",
    path: "/es/pricing-seller",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-seller.vue")
  },
  {
    name: "pricing-seller___fr",
    path: "/fr/pricing-seller",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-seller.vue")
  },
  {
    name: "pricing-seller___it",
    path: "/it/pricing-seller",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-seller.vue")
  },
  {
    name: "pricing-seller___nl",
    path: "/nl/pricing-seller",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-seller.vue")
  },
  {
    name: "pricing-seller___pl",
    path: "/pl/pricing-seller",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-seller.vue")
  },
  {
    name: "pricing-seller___pt",
    path: "/pt/pricing-seller",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-seller.vue")
  },
  {
    name: "pricing-seller___ro",
    path: "/ro/pricing-seller",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-seller.vue")
  },
  {
    name: "pricing-seller___ru",
    path: "/ru/pricing-seller",
    component: () => import("/opt/render/project/src/apps/frontend/pages/pricing-seller.vue")
  },
  {
    name: "privacy-policy___cs",
    path: "/cs/privacy-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___de",
    path: "/de/privacy-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/it/privacy-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___nl",
    path: "/nl/privacy-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___pl",
    path: "/pl/privacy-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___pt",
    path: "/pt/privacy-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ro",
    path: "/ro/privacy-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ru",
    path: "/ru/privacy-policy",
    component: () => import("/opt/render/project/src/apps/frontend/pages/privacy-policy.vue")
  },
  {
    name: "signup-confirm___cs",
    path: "/cs/signup/confirm",
    meta: confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/confirm.vue")
  },
  {
    name: "signup-confirm___de",
    path: "/de/signup/confirm",
    meta: confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/confirm.vue")
  },
  {
    name: "signup-confirm___en",
    path: "/en/signup/confirm",
    meta: confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/confirm.vue")
  },
  {
    name: "signup-confirm___es",
    path: "/es/signup/confirm",
    meta: confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/confirm.vue")
  },
  {
    name: "signup-confirm___fr",
    path: "/fr/signup/confirm",
    meta: confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/confirm.vue")
  },
  {
    name: "signup-confirm___it",
    path: "/it/signup/confirm",
    meta: confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/confirm.vue")
  },
  {
    name: "signup-confirm___nl",
    path: "/nl/signup/confirm",
    meta: confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/confirm.vue")
  },
  {
    name: "signup-confirm___pl",
    path: "/pl/signup/confirm",
    meta: confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/confirm.vue")
  },
  {
    name: "signup-confirm___pt",
    path: "/pt/signup/confirm",
    meta: confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/confirm.vue")
  },
  {
    name: "signup-confirm___ro",
    path: "/ro/signup/confirm",
    meta: confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/confirm.vue")
  },
  {
    name: "signup-confirm___ru",
    path: "/ru/signup/confirm",
    meta: confirm3pIo7v1qzm35_JuQ3LbJ97HpwSKuiLPB3GBHlULTcy8Meta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/signup/confirm.vue")
  },
  {
    name: "account-profile___cs",
    path: "/cs/account/profile",
    meta: { ...(profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___de",
    path: "/de/account/profile",
    meta: { ...(profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___en",
    path: "/en/account/profile",
    meta: { ...(profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___es",
    path: "/es/account/profile",
    meta: { ...(profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___fr",
    path: "/fr/account/profile",
    meta: { ...(profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___it",
    path: "/it/account/profile",
    meta: { ...(profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___nl",
    path: "/nl/account/profile",
    meta: { ...(profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___pl",
    path: "/pl/account/profile",
    meta: { ...(profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___pt",
    path: "/pt/account/profile",
    meta: { ...(profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___ro",
    path: "/ro/account/profile",
    meta: { ...(profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___ru",
    path: "/ru/account/profile",
    meta: { ...(profilekbygBAXobskbytCqAJvjEj4pNY0czh2rSKqqhzp0864Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/profile.vue")
  },
  {
    name: "auctions-dp-slug___cs",
    path: "/cs/aukce/dp/:slug()",
    meta: _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue")
  },
  {
    name: "auctions-dp-slug___de",
    path: "/de/auktionen/dp/:slug()",
    meta: _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue")
  },
  {
    name: "auctions-dp-slug___en",
    path: "/en/auctions/dp/:slug()",
    meta: _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue")
  },
  {
    name: "auctions-dp-slug___es",
    path: "/es/subastas/dp/:slug()",
    meta: _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue")
  },
  {
    name: "auctions-dp-slug___fr",
    path: "/fr/ventes-aux-encheres/dp/:slug()",
    meta: _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue")
  },
  {
    name: "auctions-dp-slug___it",
    path: "/it/aste/dp/:slug()",
    meta: _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue")
  },
  {
    name: "auctions-dp-slug___nl",
    path: "/nl/veilingen/dp/:slug()",
    meta: _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue")
  },
  {
    name: "auctions-dp-slug___pl",
    path: "/pl/aukcje/dp/:slug()",
    meta: _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue")
  },
  {
    name: "auctions-dp-slug___pt",
    path: "/pt/leiloes/dp/:slug()",
    meta: _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue")
  },
  {
    name: "auctions-dp-slug___ro",
    path: "/ro/licitati/dp/:slug()",
    meta: _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue")
  },
  {
    name: "auctions-dp-slug___ru",
    path: "/ru/auktsiony/dp/:slug()",
    meta: _91slug_93EMmQHK0E8S07I3Or7ZyiUIzKlr6mEMpUrQ_N3N9AG7QMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/dp/[slug].vue")
  },
  {
    name: _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta?.name,
    path: "/cs/account/orders/:id()",
    meta: { ...(_91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue"),
    children: [
  {
    name: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta?.name,
    path: "edit",
    meta: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue"),
    children: [
  {
    name: "account-orders-id-edit___cs",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue")
  },
  {
    name: "account-orders-id-edit-payment___cs",
    path: "payment",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue")
  }
]
  },
  {
    name: "account-orders-id___cs",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue")
  },
  {
    name: "account-orders-id-thank-you___cs",
    path: "thank-you",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue")
  }
]
  },
  {
    name: _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta?.name,
    path: "/de/account/orders/:id()",
    meta: { ...(_91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue"),
    children: [
  {
    name: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta?.name,
    path: "edit",
    meta: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue"),
    children: [
  {
    name: "account-orders-id-edit___de",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue")
  },
  {
    name: "account-orders-id-edit-payment___de",
    path: "payment",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue")
  }
]
  },
  {
    name: "account-orders-id___de",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue")
  },
  {
    name: "account-orders-id-thank-you___de",
    path: "thank-you",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue")
  }
]
  },
  {
    name: _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta?.name,
    path: "/en/account/orders/:id()",
    meta: { ...(_91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue"),
    children: [
  {
    name: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta?.name,
    path: "edit",
    meta: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue"),
    children: [
  {
    name: "account-orders-id-edit___en",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue")
  },
  {
    name: "account-orders-id-edit-payment___en",
    path: "payment",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue")
  }
]
  },
  {
    name: "account-orders-id___en",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue")
  },
  {
    name: "account-orders-id-thank-you___en",
    path: "thank-you",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue")
  }
]
  },
  {
    name: _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta?.name,
    path: "/es/account/orders/:id()",
    meta: { ...(_91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue"),
    children: [
  {
    name: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta?.name,
    path: "edit",
    meta: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue"),
    children: [
  {
    name: "account-orders-id-edit___es",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue")
  },
  {
    name: "account-orders-id-edit-payment___es",
    path: "payment",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue")
  }
]
  },
  {
    name: "account-orders-id___es",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue")
  },
  {
    name: "account-orders-id-thank-you___es",
    path: "thank-you",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue")
  }
]
  },
  {
    name: _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta?.name,
    path: "/fr/account/orders/:id()",
    meta: { ...(_91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue"),
    children: [
  {
    name: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta?.name,
    path: "edit",
    meta: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue"),
    children: [
  {
    name: "account-orders-id-edit___fr",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue")
  },
  {
    name: "account-orders-id-edit-payment___fr",
    path: "payment",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue")
  }
]
  },
  {
    name: "account-orders-id___fr",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue")
  },
  {
    name: "account-orders-id-thank-you___fr",
    path: "thank-you",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue")
  }
]
  },
  {
    name: _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta?.name,
    path: "/it/account/orders/:id()",
    meta: { ...(_91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue"),
    children: [
  {
    name: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta?.name,
    path: "edit",
    meta: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue"),
    children: [
  {
    name: "account-orders-id-edit___it",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue")
  },
  {
    name: "account-orders-id-edit-payment___it",
    path: "payment",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue")
  }
]
  },
  {
    name: "account-orders-id___it",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue")
  },
  {
    name: "account-orders-id-thank-you___it",
    path: "thank-you",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue")
  }
]
  },
  {
    name: _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta?.name,
    path: "/nl/account/orders/:id()",
    meta: { ...(_91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue"),
    children: [
  {
    name: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta?.name,
    path: "edit",
    meta: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue"),
    children: [
  {
    name: "account-orders-id-edit___nl",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue")
  },
  {
    name: "account-orders-id-edit-payment___nl",
    path: "payment",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue")
  }
]
  },
  {
    name: "account-orders-id___nl",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue")
  },
  {
    name: "account-orders-id-thank-you___nl",
    path: "thank-you",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue")
  }
]
  },
  {
    name: _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta?.name,
    path: "/pl/account/orders/:id()",
    meta: { ...(_91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue"),
    children: [
  {
    name: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta?.name,
    path: "edit",
    meta: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue"),
    children: [
  {
    name: "account-orders-id-edit___pl",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue")
  },
  {
    name: "account-orders-id-edit-payment___pl",
    path: "payment",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue")
  }
]
  },
  {
    name: "account-orders-id___pl",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue")
  },
  {
    name: "account-orders-id-thank-you___pl",
    path: "thank-you",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue")
  }
]
  },
  {
    name: _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta?.name,
    path: "/pt/account/orders/:id()",
    meta: { ...(_91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue"),
    children: [
  {
    name: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta?.name,
    path: "edit",
    meta: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue"),
    children: [
  {
    name: "account-orders-id-edit___pt",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue")
  },
  {
    name: "account-orders-id-edit-payment___pt",
    path: "payment",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue")
  }
]
  },
  {
    name: "account-orders-id___pt",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue")
  },
  {
    name: "account-orders-id-thank-you___pt",
    path: "thank-you",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue")
  }
]
  },
  {
    name: _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta?.name,
    path: "/ro/account/orders/:id()",
    meta: { ...(_91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue"),
    children: [
  {
    name: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta?.name,
    path: "edit",
    meta: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue"),
    children: [
  {
    name: "account-orders-id-edit___ro",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue")
  },
  {
    name: "account-orders-id-edit-payment___ro",
    path: "payment",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue")
  }
]
  },
  {
    name: "account-orders-id___ro",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue")
  },
  {
    name: "account-orders-id-thank-you___ro",
    path: "thank-you",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue")
  }
]
  },
  {
    name: _91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta?.name,
    path: "/ru/account/orders/:id()",
    meta: { ...(_91id_93z0LF8xKrgNYNJ2jJl5SOxERA8JEzIVzMA3zOpE7vvjUMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id].vue"),
    children: [
  {
    name: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta?.name,
    path: "edit",
    meta: editqgf_oDgx2tOrAKkr7Z9np_45xnMwARRPxtMqK5pHc9W3IMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit.vue"),
    children: [
  {
    name: "account-orders-id-edit___ru",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/index.vue")
  },
  {
    name: "account-orders-id-edit-payment___ru",
    path: "payment",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/edit/payment.vue")
  }
]
  },
  {
    name: "account-orders-id___ru",
    path: "",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/index.vue")
  },
  {
    name: "account-orders-id-thank-you___ru",
    path: "thank-you",
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/[id]/thank-you.vue")
  }
]
  },
  {
    name: "how-to-trust-report___cs",
    path: "/cs/navody/trust-report",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue")
  },
  {
    name: "how-to-trust-report___de",
    path: "/de/ratgeber/trust-report",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue")
  },
  {
    name: "how-to-trust-report___en",
    path: "/en/how-to/trust-report",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue")
  },
  {
    name: "how-to-trust-report___es",
    path: "/es/guias/trust-report",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue")
  },
  {
    name: "how-to-trust-report___fr",
    path: "/fr/guides/trust-report",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue")
  },
  {
    name: "how-to-trust-report___it",
    path: "/it/guide/trust-report",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue")
  },
  {
    name: "how-to-trust-report___nl",
    path: "/nl/gidsen/trust-report",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue")
  },
  {
    name: "how-to-trust-report___pl",
    path: "/pl/poradniki/trust-report",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue")
  },
  {
    name: "how-to-trust-report___pt",
    path: "/pt/guias/trust-report",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue")
  },
  {
    name: "how-to-trust-report___ro",
    path: "/ro/ghiduri/trust-report",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue")
  },
  {
    name: "how-to-trust-report___ru",
    path: "/ru/rukovodstva/trust-report",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/trust-report.vue")
  },
  {
    name: "account-orders___cs",
    path: "/cs/account/orders",
    meta: { ...(indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___de",
    path: "/de/account/orders",
    meta: { ...(indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___en",
    path: "/en/account/orders",
    meta: { ...(indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___es",
    path: "/es/account/orders",
    meta: { ...(indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___fr",
    path: "/fr/account/orders",
    meta: { ...(indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___it",
    path: "/it/account/orders",
    meta: { ...(indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___nl",
    path: "/nl/account/orders",
    meta: { ...(indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___pl",
    path: "/pl/account/orders",
    meta: { ...(indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___pt",
    path: "/pt/account/orders",
    meta: { ...(indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___ro",
    path: "/ro/account/orders",
    meta: { ...(indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/index.vue")
  },
  {
    name: "account-orders___ru",
    path: "/ru/account/orders",
    meta: { ...(indexKHDtk5KhryAyGS_45vdopL8y4oUcdxhxr8eArnzWJ2UsMMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/orders/index.vue")
  },
  {
    name: "terms-and-conditions___cs",
    path: "/cs/terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___de",
    path: "/de/terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/en/terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___es",
    path: "/es/terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___fr",
    path: "/fr/terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___it",
    path: "/it/terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___nl",
    path: "/nl/terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___pl",
    path: "/pl/terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___pt",
    path: "/pt/terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___ro",
    path: "/ro/terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___ru",
    path: "/ru/terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/terms-and-conditions.vue")
  },
  {
    name: "account-your-auctions___cs",
    path: "/cs/account/your-auctions",
    meta: { ...(your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue")
  },
  {
    name: "account-your-auctions___de",
    path: "/de/account/your-auctions",
    meta: { ...(your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue")
  },
  {
    name: "account-your-auctions___en",
    path: "/en/account/your-auctions",
    meta: { ...(your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue")
  },
  {
    name: "account-your-auctions___es",
    path: "/es/account/your-auctions",
    meta: { ...(your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue")
  },
  {
    name: "account-your-auctions___fr",
    path: "/fr/account/your-auctions",
    meta: { ...(your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue")
  },
  {
    name: "account-your-auctions___it",
    path: "/it/account/your-auctions",
    meta: { ...(your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue")
  },
  {
    name: "account-your-auctions___nl",
    path: "/nl/account/your-auctions",
    meta: { ...(your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue")
  },
  {
    name: "account-your-auctions___pl",
    path: "/pl/account/your-auctions",
    meta: { ...(your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue")
  },
  {
    name: "account-your-auctions___pt",
    path: "/pt/account/your-auctions",
    meta: { ...(your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue")
  },
  {
    name: "account-your-auctions___ro",
    path: "/ro/account/your-auctions",
    meta: { ...(your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue")
  },
  {
    name: "account-your-auctions___ru",
    path: "/ru/account/your-auctions",
    meta: { ...(your_45auctionsaE84Ot7RP2WWyDW7ODzD_45XqKnI_oxoe_mAj1_45CH2hTkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-auctions.vue")
  },
  {
    name: "accessibility-statement___cs",
    path: "/cs/accessibility-statement",
    component: () => import("/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "accessibility-statement___de",
    path: "/de/accessibility-statement",
    component: () => import("/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "accessibility-statement___en",
    path: "/en/accessibility-statement",
    component: () => import("/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "accessibility-statement___es",
    path: "/es/accessibility-statement",
    component: () => import("/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "accessibility-statement___fr",
    path: "/fr/accessibility-statement",
    component: () => import("/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "accessibility-statement___it",
    path: "/it/accessibility-statement",
    component: () => import("/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "accessibility-statement___nl",
    path: "/nl/accessibility-statement",
    component: () => import("/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "accessibility-statement___pl",
    path: "/pl/accessibility-statement",
    component: () => import("/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "accessibility-statement___pt",
    path: "/pt/accessibility-statement",
    component: () => import("/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "accessibility-statement___ro",
    path: "/ro/accessibility-statement",
    component: () => import("/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "accessibility-statement___ru",
    path: "/ru/accessibility-statement",
    component: () => import("/opt/render/project/src/apps/frontend/pages/accessibility-statement.vue")
  },
  {
    name: "account-payment-methods___cs",
    path: "/cs/account/payment-methods",
    meta: { ...(payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "account-payment-methods___de",
    path: "/de/account/payment-methods",
    meta: { ...(payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "account-payment-methods___en",
    path: "/en/account/payment-methods",
    meta: { ...(payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "account-payment-methods___es",
    path: "/es/account/payment-methods",
    meta: { ...(payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "account-payment-methods___fr",
    path: "/fr/account/payment-methods",
    meta: { ...(payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "account-payment-methods___it",
    path: "/it/account/payment-methods",
    meta: { ...(payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "account-payment-methods___nl",
    path: "/nl/account/payment-methods",
    meta: { ...(payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "account-payment-methods___pl",
    path: "/pl/account/payment-methods",
    meta: { ...(payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "account-payment-methods___pt",
    path: "/pt/account/payment-methods",
    meta: { ...(payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "account-payment-methods___ro",
    path: "/ro/account/payment-methods",
    meta: { ...(payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "account-payment-methods___ru",
    path: "/ru/account/payment-methods",
    meta: { ...(payment_45methodsNu3CGMchn447QPgf_45c1Yvg9dl1Umepi5zYTZIfSy0qkMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/payment-methods.vue")
  },
  {
    name: "how-to-how-sell-used-bus___cs",
    path: "/cs/navody/jak-prodat-pouzity-autobus",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue")
  },
  {
    name: "how-to-how-sell-used-bus___de",
    path: "/de/ratgeber/wie-gebrauchten-bus-verkaufen",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue")
  },
  {
    name: "how-to-how-sell-used-bus___en",
    path: "/en/how-to/how-sell-used-bus",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue")
  },
  {
    name: "how-to-how-sell-used-bus___es",
    path: "/es/guias/como-vender-autobus-usado",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue")
  },
  {
    name: "how-to-how-sell-used-bus___fr",
    path: "/fr/guides/comment-vendre-bus-occasion",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue")
  },
  {
    name: "how-to-how-sell-used-bus___it",
    path: "/it/guide/come-vendere-autobus-usato",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue")
  },
  {
    name: "how-to-how-sell-used-bus___nl",
    path: "/nl/gidsen/hoe-gebruikte-bus-verkopen",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue")
  },
  {
    name: "how-to-how-sell-used-bus___pl",
    path: "/pl/poradniki/jak-sprzedac-uzywany-autobus",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue")
  },
  {
    name: "how-to-how-sell-used-bus___pt",
    path: "/pt/guias/como-vender-autocarro-usado",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue")
  },
  {
    name: "how-to-how-sell-used-bus___ro",
    path: "/ro/ghiduri/cum-sa-vinzi-autobuz-second-hand",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue")
  },
  {
    name: "how-to-how-sell-used-bus___ru",
    path: "/ru/rukovodstva/kak-prodat-avtobus-bu",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/how-sell-used-bus.vue")
  },
  {
    name: "account-your-direct-sales___cs",
    path: "/cs/account/your-buy-now",
    meta: { ...(your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue")
  },
  {
    name: "account-your-direct-sales___de",
    path: "/de/account/your-buy-now",
    meta: { ...(your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue")
  },
  {
    name: "account-your-direct-sales___en",
    path: "/en/account/your-buy-now",
    meta: { ...(your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue")
  },
  {
    name: "account-your-direct-sales___es",
    path: "/es/account/your-buy-now",
    meta: { ...(your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue")
  },
  {
    name: "account-your-direct-sales___fr",
    path: "/fr/account/your-buy-now",
    meta: { ...(your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue")
  },
  {
    name: "account-your-direct-sales___it",
    path: "/it/account/your-buy-now",
    meta: { ...(your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue")
  },
  {
    name: "account-your-direct-sales___nl",
    path: "/nl/account/your-buy-now",
    meta: { ...(your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue")
  },
  {
    name: "account-your-direct-sales___pl",
    path: "/pl/account/your-buy-now",
    meta: { ...(your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue")
  },
  {
    name: "account-your-direct-sales___pt",
    path: "/pt/account/your-buy-now",
    meta: { ...(your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue")
  },
  {
    name: "account-your-direct-sales___ro",
    path: "/ro/account/your-buy-now",
    meta: { ...(your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue")
  },
  {
    name: "account-your-direct-sales___ru",
    path: "/ru/account/your-buy-now",
    meta: { ...(your_45direct_45salesh4x5RaZHwvBSTGT8wMFjLA1MNtBB_oRPZ9uzhhBs_E0Meta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sales.vue")
  },
  {
    name: "how-to-guide-buy-used-bus___cs",
    path: "/cs/navody/pruvodce-koupi-pouziteho-autobusu",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue")
  },
  {
    name: "how-to-guide-buy-used-bus___de",
    path: "/de/ratgeber/leitfaden-gebrauchten-bus-kaufen",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue")
  },
  {
    name: "how-to-guide-buy-used-bus___en",
    path: "/en/how-to/guide-buy-used-bus",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue")
  },
  {
    name: "how-to-guide-buy-used-bus___es",
    path: "/es/guias/guia-compra-autobus-usado",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue")
  },
  {
    name: "how-to-guide-buy-used-bus___fr",
    path: "/fr/guides/guide-achat-bus-occasion",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue")
  },
  {
    name: "how-to-guide-buy-used-bus___it",
    path: "/it/guide/guida-acquisto-autobus-usato",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue")
  },
  {
    name: "how-to-guide-buy-used-bus___nl",
    path: "/nl/gidsen/gids-gebruikte-bus-kopen",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue")
  },
  {
    name: "how-to-guide-buy-used-bus___pl",
    path: "/pl/poradniki/poradnik-zakupu-uzywanego-autobusu",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue")
  },
  {
    name: "how-to-guide-buy-used-bus___pt",
    path: "/pt/guias/guia-compra-autocarro-usado",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue")
  },
  {
    name: "how-to-guide-buy-used-bus___ro",
    path: "/ro/ghiduri/ghid-cumparare-autobuz-second-hand",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue")
  },
  {
    name: "how-to-guide-buy-used-bus___ru",
    path: "/ru/rukovodstva/gid-po-pokupke-avtobusa-bu",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/guide-buy-used-bus.vue")
  },
  {
    name: "direct-sales-dp-slug___cs",
    path: "/cs/okamzity-nakup/dp/:slug()",
    meta: index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue")
  },
  {
    name: "direct-sales-dp-slug___de",
    path: "/de/sofortkauf/dp/:slug()",
    meta: index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue")
  },
  {
    name: "direct-sales-dp-slug___en",
    path: "/en/buy-now/dp/:slug()",
    meta: index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue")
  },
  {
    name: "direct-sales-dp-slug___es",
    path: "/es/compra-ahora/dp/:slug()",
    meta: index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue")
  },
  {
    name: "direct-sales-dp-slug___fr",
    path: "/fr/achat-immediat/dp/:slug()",
    meta: index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue")
  },
  {
    name: "direct-sales-dp-slug___it",
    path: "/it/compra-subito/dp/:slug()",
    meta: index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue")
  },
  {
    name: "direct-sales-dp-slug___nl",
    path: "/nl/nu-kopen/dp/:slug()",
    meta: index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue")
  },
  {
    name: "direct-sales-dp-slug___pl",
    path: "/pl/kup-teraz/dp/:slug()",
    meta: index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue")
  },
  {
    name: "direct-sales-dp-slug___pt",
    path: "/pt/compra-imediata/dp/:slug()",
    meta: index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue")
  },
  {
    name: "direct-sales-dp-slug___ro",
    path: "/ro/cumpara-acum/dp/:slug()",
    meta: index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue")
  },
  {
    name: "direct-sales-dp-slug___ru",
    path: "/ru/kupit-seychas/dp/:slug()",
    meta: index_VAP_458bsxYvh0Prt9t8eGN2CmIT0OGcNkkfsXmcSHgcMeta || {},
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/index.vue")
  },
  {
    name: "how-to-reasons-buy-bus-auction___cs",
    path: "/cs/navody/duvody-k-nakupu-autobusu-v-drazbe",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue")
  },
  {
    name: "how-to-reasons-buy-bus-auction___de",
    path: "/de/ratgeber/gruende-bus-auktion-kaufen",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue")
  },
  {
    name: "how-to-reasons-buy-bus-auction___en",
    path: "/en/how-to/reasons-buy-bus-auction",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue")
  },
  {
    name: "how-to-reasons-buy-bus-auction___es",
    path: "/es/guias/razones-comprar-autobus-subasta",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue")
  },
  {
    name: "how-to-reasons-buy-bus-auction___fr",
    path: "/fr/guides/raisons-acheter-bus-enchere",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue")
  },
  {
    name: "how-to-reasons-buy-bus-auction___it",
    path: "/it/guide/motivi-per-acquistare-autobus-asta",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue")
  },
  {
    name: "how-to-reasons-buy-bus-auction___nl",
    path: "/nl/gidsen/redenen-bus-kopen-veiling",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue")
  },
  {
    name: "how-to-reasons-buy-bus-auction___pl",
    path: "/pl/poradniki/powody-zakupu-autobusu-na-aukcji",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue")
  },
  {
    name: "how-to-reasons-buy-bus-auction___pt",
    path: "/pt/guias/razoes-comprar-autocarro-leilao",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue")
  },
  {
    name: "how-to-reasons-buy-bus-auction___ro",
    path: "/ro/ghiduri/motive-cumparare-autobuz-licitatie",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue")
  },
  {
    name: "how-to-reasons-buy-bus-auction___ru",
    path: "/ru/rukovodstva/prichiny-kupit-avtobus-na-aukcione",
    component: () => import("/opt/render/project/src/apps/frontend/pages/how-to/reasons-buy-bus-auction.vue")
  },
  {
    name: "logistics-terms-and-conditions___cs",
    path: "/cs/logistics-terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue")
  },
  {
    name: "logistics-terms-and-conditions___de",
    path: "/de/logistics-terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue")
  },
  {
    name: "logistics-terms-and-conditions___en",
    path: "/en/logistics-terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue")
  },
  {
    name: "logistics-terms-and-conditions___es",
    path: "/es/logistics-terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue")
  },
  {
    name: "logistics-terms-and-conditions___fr",
    path: "/fr/logistics-terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue")
  },
  {
    name: "logistics-terms-and-conditions___it",
    path: "/it/logistics-terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue")
  },
  {
    name: "logistics-terms-and-conditions___nl",
    path: "/nl/logistics-terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue")
  },
  {
    name: "logistics-terms-and-conditions___pl",
    path: "/pl/logistics-terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue")
  },
  {
    name: "logistics-terms-and-conditions___pt",
    path: "/pt/logistics-terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue")
  },
  {
    name: "logistics-terms-and-conditions___ro",
    path: "/ro/logistics-terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue")
  },
  {
    name: "logistics-terms-and-conditions___ru",
    path: "/ru/logistics-terms-and-conditions",
    component: () => import("/opt/render/project/src/apps/frontend/pages/logistics-terms-and-conditions.vue")
  },
  {
    name: "direct-sales-dp-slug-negotiation___cs",
    path: "/cs/okamzity-nakup/dp/:slug()/jednani",
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue")
  },
  {
    name: "direct-sales-dp-slug-negotiation___de",
    path: "/de/sofortkauf/dp/:slug()/verhandlung",
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue")
  },
  {
    name: "direct-sales-dp-slug-negotiation___en",
    path: "/en/buy-now/dp/:slug()/negotiation",
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue")
  },
  {
    name: "direct-sales-dp-slug-negotiation___es",
    path: "/es/compra-ahora/dp/:slug()/negociacion",
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue")
  },
  {
    name: "direct-sales-dp-slug-negotiation___fr",
    path: "/fr/achat-immediat/dp/:slug()/negociation",
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue")
  },
  {
    name: "direct-sales-dp-slug-negotiation___it",
    path: "/it/compra-subito/dp/:slug()/negoziazione",
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue")
  },
  {
    name: "direct-sales-dp-slug-negotiation___nl",
    path: "/nl/nu-kopen/dp/:slug()/onderhandeling",
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue")
  },
  {
    name: "direct-sales-dp-slug-negotiation___pl",
    path: "/pl/kup-teraz/dp/:slug()/negocjacja",
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue")
  },
  {
    name: "direct-sales-dp-slug-negotiation___pt",
    path: "/pt/compra-imediata/dp/:slug()/negociacao",
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue")
  },
  {
    name: "direct-sales-dp-slug-negotiation___ro",
    path: "/ro/cumpara-acum/dp/:slug()/negociere",
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue")
  },
  {
    name: "direct-sales-dp-slug-negotiation___ru",
    path: "/ru/kupit-seychas/dp/:slug()/peregovory",
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/dp/[slug]/negotiation.vue")
  },
  {
    name: "account-your-direct-sale-buyer-negotiations___cs",
    path: "/cs/account/your-direct-sale-buyer-negotiations",
    meta: { ...(your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue")
  },
  {
    name: "account-your-direct-sale-buyer-negotiations___de",
    path: "/de/account/your-direct-sale-buyer-negotiations",
    meta: { ...(your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue")
  },
  {
    name: "account-your-direct-sale-buyer-negotiations___en",
    path: "/en/account/your-direct-sale-buyer-negotiations",
    meta: { ...(your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue")
  },
  {
    name: "account-your-direct-sale-buyer-negotiations___es",
    path: "/es/account/your-direct-sale-buyer-negotiations",
    meta: { ...(your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue")
  },
  {
    name: "account-your-direct-sale-buyer-negotiations___fr",
    path: "/fr/account/your-direct-sale-buyer-negotiations",
    meta: { ...(your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue")
  },
  {
    name: "account-your-direct-sale-buyer-negotiations___it",
    path: "/it/account/your-direct-sale-buyer-negotiations",
    meta: { ...(your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue")
  },
  {
    name: "account-your-direct-sale-buyer-negotiations___nl",
    path: "/nl/account/your-direct-sale-buyer-negotiations",
    meta: { ...(your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue")
  },
  {
    name: "account-your-direct-sale-buyer-negotiations___pl",
    path: "/pl/account/your-direct-sale-buyer-negotiations",
    meta: { ...(your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue")
  },
  {
    name: "account-your-direct-sale-buyer-negotiations___pt",
    path: "/pt/account/your-direct-sale-buyer-negotiations",
    meta: { ...(your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue")
  },
  {
    name: "account-your-direct-sale-buyer-negotiations___ro",
    path: "/ro/account/your-direct-sale-buyer-negotiations",
    meta: { ...(your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue")
  },
  {
    name: "account-your-direct-sale-buyer-negotiations___ru",
    path: "/ru/account/your-direct-sale-buyer-negotiations",
    meta: { ...(your_45direct_45sale_45buyer_45negotiations1pUeNorUeZrFu_45gBMyv78cz46bm_e_jnOeBltn6GgWAMeta || {}), ...{"middleware":"auth-guard"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/account/your-direct-sale-buyer-negotiations.vue")
  },
  {
    name: "auctions-localizedAssetType-optionalParams___cs",
    path: "/cs/aukce/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "auctions-localizedAssetType-optionalParams___de",
    path: "/de/auktionen/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "auctions-localizedAssetType-optionalParams___en",
    path: "/en/auctions/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "auctions-localizedAssetType-optionalParams___es",
    path: "/es/subastas/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "auctions-localizedAssetType-optionalParams___fr",
    path: "/fr/ventes-aux-encheres/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "auctions-localizedAssetType-optionalParams___it",
    path: "/it/aste/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "auctions-localizedAssetType-optionalParams___nl",
    path: "/nl/veilingen/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "auctions-localizedAssetType-optionalParams___pl",
    path: "/pl/aukcje/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "auctions-localizedAssetType-optionalParams___pt",
    path: "/pt/leiloes/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "auctions-localizedAssetType-optionalParams___ro",
    path: "/ro/licitati/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "auctions-localizedAssetType-optionalParams___ru",
    path: "/ru/auktsiony/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93SmUopKu3iiveBAG526kXqcTTK6j0rQCduWV1OBVy81sMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/auctions/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "direct-sales-localizedAssetType-optionalParams___cs",
    path: "/cs/okamzity-nakup/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "direct-sales-localizedAssetType-optionalParams___de",
    path: "/de/sofortkauf/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "direct-sales-localizedAssetType-optionalParams___en",
    path: "/en/buy-now/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "direct-sales-localizedAssetType-optionalParams___es",
    path: "/es/compra-ahora/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "direct-sales-localizedAssetType-optionalParams___fr",
    path: "/fr/achat-immediat/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "direct-sales-localizedAssetType-optionalParams___it",
    path: "/it/compra-subito/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "direct-sales-localizedAssetType-optionalParams___nl",
    path: "/nl/nu-kopen/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "direct-sales-localizedAssetType-optionalParams___pl",
    path: "/pl/kup-teraz/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "direct-sales-localizedAssetType-optionalParams___pt",
    path: "/pt/compra-imediata/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "direct-sales-localizedAssetType-optionalParams___ro",
    path: "/ro/cumpara-acum/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: "direct-sales-localizedAssetType-optionalParams___ru",
    path: "/ru/kupit-seychas/:localizedAssetType()/:optionalParams(.*)*",
    meta: { ...(_91_46_46_46optionalParams_93Jb1ITALlQ_tKcCV_45_45kiFQ9wAFuDaNlgFslToXJYv17EMeta || {}), ...{"middleware":"slp"} },
    component: () => import("/opt/render/project/src/apps/frontend/pages/direct-sales/[localizedAssetType]/[...optionalParams].vue")
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/pl/aukcje/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/pl/aukcje/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/pl/aukcje/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/pl/aukcje/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/pl/aukcje/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/pl/aukcje/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/pl/aukcje/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/pl/aukcje/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/pl/aukcje/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/pl/aukcje/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/pl/aukcje/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/pl/kup-teraz/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/pl/kup-teraz/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/pl/kup-teraz/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/pl/kup-teraz/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/pl/kup-teraz/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/pl/kup-teraz/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/pl/kup-teraz/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/pl/kup-teraz/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/pl/kup-teraz/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/pl/kup-teraz/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/pl/kup-teraz/autobus/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/nl/veilingen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/nl/veilingen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/nl/veilingen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/nl/veilingen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/nl/veilingen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/nl/veilingen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/nl/veilingen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/nl/veilingen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/nl/veilingen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/nl/veilingen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/nl/veilingen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/nl/nu-kopen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/nl/nu-kopen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/nl/nu-kopen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/nl/nu-kopen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/nl/nu-kopen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/nl/nu-kopen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/nl/nu-kopen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/nl/nu-kopen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/nl/nu-kopen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/nl/nu-kopen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/nl/nu-kopen/Bussen/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/cs/aukce/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/cs/aukce/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/cs/aukce/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/cs/aukce/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/cs/aukce/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/cs/aukce/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/cs/aukce/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/cs/aukce/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/cs/aukce/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/cs/aukce/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/cs/aukce/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/cs/okamzity-nakup/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/cs/okamzity-nakup/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/cs/okamzity-nakup/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/cs/okamzity-nakup/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/cs/okamzity-nakup/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/cs/okamzity-nakup/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/cs/okamzity-nakup/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/cs/okamzity-nakup/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/cs/okamzity-nakup/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/cs/okamzity-nakup/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/cs/okamzity-nakup/Autobusy/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/ru/auktsiony/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/ru/auktsiony/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/ru/auktsiony/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/ru/auktsiony/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/ru/auktsiony/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/ru/auktsiony/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/ru/auktsiony/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/ru/auktsiony/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/ru/auktsiony/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/ru/auktsiony/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/ru/auktsiony/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/ru/kupit-seychas/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/ru/kupit-seychas/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/ru/kupit-seychas/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/ru/kupit-seychas/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/ru/kupit-seychas/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/ru/kupit-seychas/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/ru/kupit-seychas/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/ru/kupit-seychas/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/ru/kupit-seychas/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/ru/kupit-seychas/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/ru/kupit-seychas/%D0%B0%D0%B2%D1%82%D0%BE%D0%B1%D1%83%D1%81%D1%8B/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/de/auktion/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/de/auktion/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/de/auktion/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/de/auktion/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/de/auktion/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/de/auktion/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/de/auktion/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/de/auktion/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/de/auktion/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/de/auktion/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/de/auktion/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/en/auction/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/en/auction/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/en/auction/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/en/auction/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/en/auction/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/en/auction/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/en/auction/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/en/auction/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/en/auction/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/en/auction/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/en/auction/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/es/subasta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/es/subasta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/es/subasta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/es/subasta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/es/subasta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/es/subasta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/es/subasta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/es/subasta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/es/subasta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/es/subasta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/es/subasta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/fr/vente-aux-encheres/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/fr/vente-aux-encheres/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/fr/vente-aux-encheres/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/fr/vente-aux-encheres/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/fr/vente-aux-encheres/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/fr/vente-aux-encheres/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/fr/vente-aux-encheres/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/fr/vente-aux-encheres/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/fr/vente-aux-encheres/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/fr/vente-aux-encheres/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/fr/vente-aux-encheres/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/it/asta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/it/asta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/it/asta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/it/asta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/it/asta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/it/asta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/it/asta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/it/asta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/it/asta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/it/asta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/it/asta/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/pl/aukcja/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/pl/aukcja/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/pl/aukcja/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/pl/aukcja/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/pl/aukcja/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/pl/aukcja/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/pl/aukcja/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/pl/aukcja/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/pl/aukcja/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/pl/aukcja/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/pl/aukcja/:pathMatch(.*)",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/cs/sitemap.xml",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/nl/sitemap.xml",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pl/sitemap.xml",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/pt/sitemap.xml",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ro/sitemap.xml",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  },
  {
    name: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXMMeta?.name,
    path: "/ru/sitemap.xml",
    component: component_45stubbWF0n7GFTz5FiaNZOsiBT23nuEoK6siEKmJPss9kwXM
  }
]